/**
 * Decodes a JWT token without verification (frontend decoding only)
 * @param {string} token - JWT token string
 * @returns {object|null} - Decoded token payload or null if invalid
 */
export function decodeJWT(token) {
  if (!token) return null;

  try {
    // JWT structure: header.payload.signature
    const parts = token.split(".");

    if (parts.length !== 3) return null;

    // Decode the payload (second part)
    const payload = parts[1];

    // Replace URL-safe characters and add padding if needed
    const base64 = payload.replace(/-/g, "+").replace(/_/g, "/");
    const paddedBase64 = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), "=");

    // Decode base64
    const jsonPayload = decodeURIComponent(
      atob(paddedBase64)
        .split("")
        .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
        .join("")
    );

    return JSON.parse(jsonPayload);
  } catch (error) {
    return null;
  }
}
